import React from "react";

const MAP = {
  // quotes
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  sent: { label: "Sent", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  converted: { label: "Converted", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  // jobs
  unscheduled: { label: "Unscheduled", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  scheduled: { label: "Scheduled", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  in_progress: { label: "In Progress", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "Cancelled", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  // invoices
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  overdue: { label: "Overdue", cls: "bg-orange-50 text-orange-700 border-orange-200" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-md border text-[11px] font-bold uppercase tracking-wider ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
